import UniformPage from "../components/pages/UniformPage";

export default UniformPage;
